module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7r2n5r-b1d1128666c3600270382dd4e1739dc2.svg";